import { ClickEvent, Cursor, TableSelectionEvent } from "@mcleod/components";
import { ElectronicAdvances } from "../ElectronicAdvances";
import { WireUtil } from "../WireUtil";
import { AutogenLayoutDriverList } from "./autogen/AutogenLayoutDriverList";

export class DriverList extends AutogenLayoutDriverList {

    private movementId: string;
    private orderId: string;
    private moveType: string;
    private shouldValidatePayee: boolean;
    private permissionsResponse: any;

    override async onLoad(): Promise<void> {
        await this.setupAdvancesButton();

        this.tableDriver.addSelectionListener(async (event: TableSelectionEvent) => {
            if (!this.permissionsResponse?.visible_driver_advances) {
                return;
            }

            const selectedRow = this.tableDriver.selectedRow;
            if (!selectedRow) {
                this.driverAdvanceButton.visible = false;
                return;
            }

            const driverId = selectedRow.data.get("id");
            const driverName = WireUtil.fullName(selectedRow.data.get("first_name"), selectedRow.data.get("name"));
            const response = await WireUtil.userPermissionForWireCode();
            let iconVisible = response?.visible_driver_advances;
            let iconEnable = response?.enabled_driver_advances;
            let tooltipMessage = response?.tooltip_message;
            this.shouldValidatePayee = iconEnable && iconVisible;
            if (this.shouldValidatePayee) {
                const responseOrderMovement = await WireUtil.driverOrderAndMovements(driverId);
                this.movementId = responseOrderMovement?.movement_id;
                this.orderId = responseOrderMovement?.order_id;
                this.moveType = responseOrderMovement?.move_type;
                const responseValidationIcon = await WireUtil.validateDriverAdvanceIcon(driverId, driverName);
                tooltipMessage = responseValidationIcon?.tooltip_message
                iconVisible = responseValidationIcon?.visible_driver_advances;
                iconEnable = responseValidationIcon?.enabled_driver_advances;
            }
            this.driverAdvanceButton.cursor = iconEnable ? Cursor.POINTER : null;
            this.driverAdvanceButton.visible = iconVisible;
            this.driverAdvanceButton.enabled = iconEnable;
            this.driverAdvanceButton.tooltip = tooltipMessage;
        });
    }

    private async setupAdvancesButton() {
        this.driverAdvanceButton.visible = false;
        if (WireUtil.isUserDeniedAccessToLayout()) {
            return;
        }
        this.permissionsResponse = await WireUtil.userPermissionForWireCode();
    }

    driverAdvanceButtonOnClick(event: ClickEvent) {
        const selectedRow = this.tableDriver.selectedRow;
        const driverId = selectedRow.data.get("id");
        const driverName = WireUtil.fullName(selectedRow.data.get("first_name"), selectedRow.data.get("name"));
        const options = {
            movementId: this.movementId,
            movementBrokerage: false,
            orderId: this.orderId,
            driverId: driverId,
            driverName: driverName,
            validatedFrom: "Master Driver",
            moveType: this.moveType
        };
        ElectronicAdvances.showSlider(options);
    }
}
